import { getIsDraft } from '../../application/pageDataObject'
import { external as externalScript } from '../../utils/script'
import { getIsNativeApp, getIsMobileOrTablet, path } from '../../utils/ua'
import { externalScriptsConfig } from '../config/externalScripts'
import initRiddleEmbeds from '../../providers/riddle/riddleEmbedProvider'
import initNewscorp from '../../providers/newscorp/newscorpEmbedProvider'
import initTwitterEmbeds from '../../providers/twitter/twitterEmbedProvider'
import initAdblockDetectorProvider from '../../providers/ads/adblockDetectorProvider'
// disabled until biz issues are resolved.
// import initScribblelive from '../../providers/scribblelive/scribbleliveEmbedProvider';

// Routing initialization
require('../../providers/routingProvider')

// Embeds initialization
require('../../providers/embed/embedGuestProvider')
require('../../providers/newscorp/newscorpEmbedProvider')
require('../../providers/facebook/facebookEmbedProvider')
require('../../providers/playbuzz/playbuzzEmbedProvider')

const { isFullLayout, isEmbedded } = path

if (!getIsMobileOrTablet() && isFullLayout && !getIsDraft()) {
  require('../../providers/dialogProvider')
}

initTwitterEmbeds()
initRiddleEmbeds()

function addNameAndLoadNow(scriptConf) {
  return {
    loadNow: true,
    name: scriptConf.name,
  }
}

const externalsToLoad = []

// if (!getIsNativeApp() && !isEmbedded) {
//   externalsToLoad.push(externalScriptsConfig.perimeterX)
// }

initNewscorp()
// initScribblelive();

initAdblockDetectorProvider()

externalScript.loadAll.apply(null, externalsToLoad.map(addNameAndLoadNow))



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/providersInitializer.js